import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from './wizard-actions';
import {exhaustMap, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {WizardRestService} from '@core/modules/rest/wizard/wizard-rest.service';

@Injectable()
export class WizardEffects {

    constructor(private actions$: Actions, private wizardRestService: WizardRestService) {
    }

    getWizardContent$ = createEffect(() => {
            return this.actions$
                .pipe(
                    ofType(fromActions.GetWizardContent),
                    exhaustMap((action: ReturnType<typeof fromActions.GetWizardContent>) => {
                        return this.wizardRestService.getWizardContent(action.consentId)
                            .pipe(
                                map((response: string) => fromActions.GetWizardContentSuccess({
                                    wizardContent: response
                                }))
                            );
                    })
                );
        }
    );
}
